module.exports = __webpack_public_path__ + "static/media/iconomegustogris.db0337df.svg";